// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import pieChart01Icon from "@/assets/icons/pie-chart-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PieChart01IconProps = Omit<IconProps, "name">;

export function PieChart01Icon(props: PieChart01IconProps): React.ReactNode {
  return <Icon name={pieChart01Icon} {...props} />;
}
